import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  allowStudentDirectMessages: Yup.boolean(),
  notAfter: Yup.date(),
  notBefore: Yup.date(),
});
